import { render, staticRenderFns } from "./RewardsMenu.vue?vue&type=template&id=0560b192&scoped=true"
import script from "./RewardsMenu.vue?vue&type=script&lang=js"
export * from "./RewardsMenu.vue?vue&type=script&lang=js"
import style0 from "./RewardsMenu.vue?vue&type=style&index=0&id=0560b192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560b192",
  null
  
)

export default component.exports